// extracted by mini-css-extract-plugin
export default {"modalHeader":"CustomFormModal_modalHeader__bsL1d","btn":"CustomFormModal_btn__kkQCQ"};